export const sendRequest = async (model, prompt, onStreamData, api_base, api_key, signal, conversationHistory = []) => {
    try {
        // 构建消息数组，包含历史对话和当前提问
        const messages = [
            ...conversationHistory.map(msg => ({
                role: msg.role,
                content: msg.content
            })),
            {
                role: "user",
                content: prompt
            }
        ];

        const response = await fetch(`${api_base}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${api_key}`
            },
            body: JSON.stringify({
                model: model,
                messages: messages,
                stream: true
            }),
            signal,
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        let done = false;
        while (!done) {
            const {value, done: readerDone} = await reader.read();
            if (readerDone) {
                done = true;
                break;
            }

            const chunk = decoder.decode(value);
            const lines = chunk.split('\n').filter(line => line.trim() !== '');

            for (const line of lines) {
                const message = line.replace(/^data: /, '');
                //console.log('Parsed message:', message);
                if (message === '[DONE]') {
                    done = true;
                } else {
                    try {
                        const json = JSON.parse(message);
                        //console.log('Parsed JSON:', json);
                        if (json.choices && json.choices[0].delta && json.choices[0].delta.content) {
                            //console.log('JSON content:', json)
                            onStreamData(json.choices[0].delta.content);
                        }
                    } catch (e) {
                        //console.error('Failed to parse stream message:', e);
                    }
                }
            }
        }
        //console.log('Stream finished':);
    } catch (error) {
        console.error('Failed to fetch data from OneAPI:', error);
        throw error;
    }
};
